import { Box, CircularProgress, Typography } from "@mui/material";
import { useProducts } from "Hooks/useProducts";
import { useState } from "react";
import { useUpdateEffect } from "react-use";
import { CenterPage } from "Components/CenterPage/CenterPage";
import ProductRankingInner from "./ProductRankingInner";
import { ExplorerSidebar, useExplorerContext } from "features/explorer";
import ExplorerTopBar from "features/explorer/components/ExplorerTopBar";

function ProductsRanking({}) {
  const { products } = useProducts();
  const [showLoadingState, setShowLoadingState] = useState(false);
  const { config, dimension, selectedRanks, having } = useExplorerContext();
  const [open, setOpen] = useState(false);

  useUpdateEffect(() => {
    setShowLoadingState(true);
    setTimeout(() => {
      setShowLoadingState(false);
    }, 500);
  }, [selectedRanks, having]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        gap: 2,
        height: "100%",
      }}
    >
      <ExplorerTopBar onOpenSidebar={() => setOpen(true)} />

      <Box sx={{ flex: 1 }} pb={2}>
        {showLoadingState ? (
          <CenterPage>
            <CircularProgress />
            <Typography variant="h3" mt={2}>
              Fetching Product's Data
            </Typography>
          </CenterPage>
        ) : (
          <ProductRankingInner
            products={products}
            config={config}
            dimension={dimension}
            ranks={selectedRanks}
            having={having}
          />
        )}
      </Box>

      <ExplorerSidebar
        open={open}
        onClose={() => setOpen(false)}
        filterTitle="Filter Products"
      />
    </Box>
  );
}

export default ProductsRanking;
